import React from 'react';
import {inject, observer} from 'mobx-react';
import Slide from '../Slide';

import './index.scss';

@inject(({store}) => ({
    headImgs: store.renderData.bg.data.headImgs
}))
@observer
class Banner extends React.Component {
    render() {
        const {headImgs = []} = this.props;

        if (!headImgs.length) {
            return null;
        }
        return <div className="m-top">
            <Slide setting={{autoplay: true}}>
                {
                    headImgs.map((v, k) => {
                        const {img = {}} = v;
                        return <img className="img" key={k} src={img.touch} />;
                    })
                }
            </Slide>
        </div>;
    }
}

export default Banner;